import { defineMessages } from 'react-intl';

const messages = defineMessages({
  eventInfo: {
    id: 'Event Information',
    defaultMessage: 'Event Information',
  },
  customSections: {
    id: 'Custom Sections',
    defaultMessage: 'Custom Sections',
  },
  customSectionsDescription: {
    id: 'Add additional information sections to display below the event details',
    defaultMessage:
      'Add additional information sections to display below the event details',
  },
  sectionIcon: {
    id: 'Icon',
    defaultMessage: 'Icon',
  },
  sectionIconDescription: {
    id: 'FontAwesome icon class (e.g., "fas fa-info-circle")',
    defaultMessage: 'FontAwesome icon class (e.g., "fas fa-info-circle")',
  },
  sectionTitle: {
    id: 'Section Title',
    defaultMessage: 'Section Title',
  },
  sectionContent: {
    id: 'Content',
    defaultMessage: 'Content',
  },
  customSectionsHelp: {
    id: 'Event Info - Custom Sections Help',
    defaultMessage:
      'The main event information (date, time, location, attendees, and contact details) is managed in the Event tab. Use this section only to add additional custom sections to display below the event details.',
  },
});

// Schema para cada item da lista de seções customizadas
export const CustomSectionSchema = (intl) => ({
  title: intl.formatMessage(messages.customSections),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['icon', 'title', 'content'],
    },
  ],
  properties: {
    icon: {
      title: intl.formatMessage(messages.sectionIcon),
      description: intl.formatMessage(messages.sectionIconDescription),
      type: 'string',
    },
    title: {
      title: intl.formatMessage(messages.sectionTitle),
      type: 'string',
    },
    content: {
      title: intl.formatMessage(messages.sectionContent),
      type: 'string',
    },
  },
  required: ['title'],
});

const EventInfoSchema = ({ intl }) => ({
  title: intl.formatMessage(messages.eventInfo),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['customSectionsHelp', 'customSections'],
    },
  ],
  properties: {
    hasBeenEdited: {
      type: 'boolean',
      default: false,
    },
    customSectionsHelp: {
      widget: 'help_message_widget',
      body: intl.formatMessage(messages.customSectionsHelp),
    },
    customSections: {
      title: intl.formatMessage(messages.customSections),
      description: intl.formatMessage(messages.customSectionsDescription),
      widget: 'object_list',
      schema: CustomSectionSchema(intl),
      placeholderItemField: 'title',
    },
  },
  required: [],
});

export default EventInfoSchema;
